module.exports = __webpack_public_path__ + "assets/1385b0a208cd9304c2f7df3fdbc3acfe.mp3";